import { CalendarClock } from "lucide-react";

export default function StayTuned({ className = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 border border-white/12 bg-black/40 backdrop-blur px-5 py-4 ${className}`} data-testid="stay-tuned">
      <CalendarClock className="text-[#ff7a1a] shrink-0" size={28} />
      <div>
        <div className="font-display text-3xl sm:text-4xl uppercase leading-none pas-gradient-text">Stay Tuned</div>
        <div className="font-heading text-xs sm:text-sm uppercase tracking-widest text-[#8a8d91] mt-1">2027 dates to be announced</div>
      </div>
    </div>
  );
}
